import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { TThunkDispatch } from '../../../../common/types/redux';
import { fetchInfrastructureFeatures, fetchInfrastructureTypesByBbox } from '../../../actions/infrastructure';
import { selectActiveType, selectMinZoom, selectMapBounds } from '../../../selectors';

interface IUseInfrastructurePinsFetchingParams {
  enabled: boolean;
}

export function useInfrastructurePinsFetching({ enabled }: IUseInfrastructurePinsFetchingParams): void {
  const dispatch = useDispatch<TThunkDispatch>();
  const mapBounds = useSelector(selectMapBounds);
  const activeType = useSelector(selectActiveType);
  const minZoom = useSelector(selectMinZoom);

  React.useEffect(() => {
    if (!enabled) {
      return;
    }

    if (mapBounds.zoom > minZoom) {
      dispatch(fetchInfrastructureFeatures());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, mapBounds, activeType?.id]);

  React.useEffect(() => {
    if (!enabled) {
      return;
    }

    dispatch(fetchInfrastructureTypesByBbox());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, mapBounds]);
}
